require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/kiosks.template.htm');
var KiosksTable = require('text-loader!../templates/kiosks_table.template.htm');
var Collection = require('../models/kiosks.paginated.collection.ts');
require('dhtmlxMessage');
var Pagination = require('../views/pagination.view.ts');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var i18n = require("l10n");
var popup = require('popup');

var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	kiosksTable: Handlebars.compile(KiosksTable),
	superInitialize: GenericView.prototype.initialize,
    collection : null,
    userData: null,
	privilegeLevel: "",
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function (options) {
        var self = this;

        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.collection = new Collection();
        // TODO: change url into kiosks 
        this.collection.url = '/rest/api/kiosks';
        this.collection.on( 'sync', this.successKiosksData, this );
        this.collection.on( 'error', this.errorKiosksData, this );
        this.collection.getFirstPage();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template({ privilegeLevel: this.privilegeLevel }));
	},
	events: {
        "click .edit_kiosk": "editKiosk",
        "keyup #search": "search",
        "click #deleteBtn": "deleteKiosk"
	},
    search: function(event)
    {
        element = $(event.currentTarget);
		var text = element.val().trim();
        // TODO: change urls
        if(this.lastSearchedText != text )
        {
            $.ajaxq.abort("DefaultQueue");
            this.lastSearchedText = text;
            this.collection.url = '/rest/api/kiosks?q=' + encodeURIComponent(element.val().trim());
            this.collection.getFirstPage();
        }
    },
    successKiosksData: function()
    {
        var self = this;
        self.hideActionProgressBar();

        if(this.isFirstDisplay)
        {
            this.isFirstDisplay = false;
            this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
        }
        $('#table-container').html(this.kiosksTable(
            {
                "kiosks" : this.collection.models,
                pageInfo : this.collection.info(),
                privilegeLevel: this.privilegeLevel
            })
         );

        this.pagination = new Pagination({ collection : this.collection });
        this.pagination.render();
        $( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

        if(this.collection.models.length > 0)
        {
            $('#table-container').show();
            $('#pagination').show();
            $('#empty').hide();

            self.initializeTrs(this.showHideActionButton, "#dataTables");
        }
        else
        {
            $('#table-container').hide();
            $('#pagination').hide();
            $('#empty').show();
        }

    },
    showHideActionButton: function(flag) {
        GenericView.prototype.showHideActionButton(flag, "#deleteBtn", "#dataTables");
    },
    errorKiosksData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
	editKiosk: function(e) {
	    window.location.href = "#Kiosk/"+$(e.currentTarget).parent().data("id");
	},
    deleteKiosk: function() {

        var self = this;

        var ids = "";
        $("#dataTables").find("td input:checked").each( function() {
            ids += ($(this).parent().data("id")) +",";
        });

        url = '/rest/api/kiosks?ids=' + ids.slice(0,-1);

        var params = {
            "url": url,
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.confirm_delete"), i18n.t("pageHeader.delete_msg"), "confirm_delete", params);

    }

});

module.exports = TheView;